import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const FEATURES = [
  "100+ practical writing prompts",
  "Everyday writing workflows",
  "Copy-ready templates",
  "Beginner-friendly guide",
  "Instant digital access",
];

const Featured = () => {
  return (
    <section
      data-testid="section-featured"
      className="bg-[#F7F7F4]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Left side - title and body */}
          <div className="lg:col-span-5">
            <div className="overline">— Featured</div>
            <h2 className="mt-5 font-sora text-[36px] sm:text-[44px] lg:text-[54px] font-bold text-[#111111] tracking-tight leading-[1.05]">
              Start with the
              <br />
              AI Writing Kit.
            </h2>
            <p className="mt-7 font-manrope text-[16px] md:text-[17px] text-[#111111]/65 leading-relaxed max-w-md">
              A simple starter kit for people who want to write better emails,
              captions, notes, summaries, ideas, and everyday content using AI.
            </p>

            <div className="mt-10 flex flex-col items-start gap-3">
              <a
                href="https://vaymilo.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="link-featured-product"
                className="inline-flex items-center gap-2 bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-manrope font-medium text-[15px] px-6 py-3.5 rounded-lg transition-colors"
              >
                View product
                <ArrowUpRight size={16} strokeWidth={2.25} />
              </a>
              <Link
                to="/products/ai-writing-kit"
                data-testid="link-featured-detail"
                className="font-manrope text-sm text-[#111111] hover:text-[#2563EB] transition-colors border-b border-[#E7E7E2] hover:border-[#2563EB] pb-0.5"
              >
                See full details →
              </Link>
            </div>
          </div>

          {/* Right side - product detail card */}
          <div className="lg:col-span-7">
            <div className="bg-white border border-[#E7E7E2] rounded-2xl overflow-hidden">
              <div className="px-7 md:px-10 py-6 border-b border-[#E7E7E2] flex items-center justify-between">
                <div>
                  <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-[#111111]/45">
                    Vaymilo Kit · 001
                  </div>
                  <div className="mt-1 font-sora text-[20px] font-semibold text-[#111111]">
                    AI Writing Kit
                  </div>
                </div>
                <div className="hidden sm:flex flex-col items-end">
                  <span className="font-mono text-[11px] tracking-[0.16em] uppercase text-[#111111]/45">
                    Format
                  </span>
                  <span className="mt-1 font-manrope text-sm text-[#111111]">
                    Digital · Instant
                  </span>
                </div>
              </div>

              <div className="px-7 md:px-10 py-8 md:py-10">
                <div className="font-sora text-[11px] font-bold tracking-[0.2em] uppercase text-[#111111]/50">
                  What you get
                </div>
                <ul className="mt-5 divide-y divide-[#E7E7E2]">
                  {FEATURES.map((f, idx) => (
                    <li
                      key={f}
                      className="flex items-baseline gap-5 py-4 font-manrope text-[16px] md:text-[17px] text-[#111111]"
                    >
                      <span className="font-mono text-xs text-[#111111]/40 w-6">
                        0{idx + 1}
                      </span>
                      <span className="flex-1">{f}</span>
                      <span className="text-[#2563EB] font-mono text-sm">
                        +
                      </span>
                    </li>
                  ))}
                </ul>

                <div className="mt-8 grid grid-cols-2 gap-px bg-[#E7E7E2] border border-[#E7E7E2] rounded-lg overflow-hidden">
                  <div className="bg-white px-5 py-4">
                    <div className="font-mono text-[10px] tracking-[0.18em] uppercase text-[#111111]/45">
                      Audience
                    </div>
                    <div className="mt-1 font-manrope text-[14px] text-[#111111]">
                      Students, creators, freelancers
                    </div>
                  </div>
                  <div className="bg-white px-5 py-4">
                    <div className="font-mono text-[10px] tracking-[0.18em] uppercase text-[#111111]/45">
                      Access
                    </div>
                    <div className="mt-1 font-manrope text-[14px] text-[#111111]">
                      Instant · Or via Studio
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Featured;
